'use client';

import { useEffect, useState } from 'react';
import { HEADER_MEGA_MENU_QUERY } from '@workspace/sanity-base/queries/header';
import { noCdnClient } from '@/sanity/lib/client';
import type { IHeaderData } from '@workspace/interfaces/header';

export const useHeader = () => {
  const [headerData, setHeaderData] = useState<IHeaderData | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchHeader = async () => {
      try {
        setLoading(true);
        const query = HEADER_MEGA_MENU_QUERY;
        const data = await noCdnClient.fetch(query);
        setHeaderData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch header data');
      } finally {
        setLoading(false);
      }
    };

    fetchHeader();
  }, []);

  return { headerData, loading, error };
};
